import React from "react";

const AgeDisclaimer = () => {
  return (
    <div className="bg-gray-800/50 rounded-lg p-4 backdrop-blur-sm border border-gray-700/50">
      <p className="text-gray-400 text-sm leading-relaxed">
        <span className="text-cannabis-green-300 font-semibold">
          For adults 21 years of age or older.
        </span>{" "}
        Cannabis has intoxicating effects and may be habit forming. Keep out of
        reach of children.
      </p>
    </div>
  );
};

export default AgeDisclaimer;
